var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full lg:w-1/2"},[_c('user-account-details-basic-information-basic')],1),_c('div',{staticClass:"vx-col w-full lg:w-1/2 mt-base pt-base lg:mt-0 lg:pt-0"},[_c('user-account-details-basic-information-notification-preferences')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }